import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
} from 'reactstrap';

const ModalDetailPerangkat = ({ data, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData }) => {
	
	const frmLembaga = {
		uuid: '',
		nama_lembaga: '',
		tahun_berdiri: '',
		status: 1,
	}

	const [dt, setDt] = useState(data ? data : frmLembaga)

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmLembaga)
	}, [isOpen])

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				// onSubmit={simpan} 
			>
				<div className="modal-header">
					<h5 className="modal-title">Detail Perangkat Lembaga</h5>
				</div>
				<div className="modal-body">
					{
						dt.foto
						?
						<>
							<div className="col-md-12 text-center">
								<img alt="foto_perangkat" src={dt.foto} style={{ maxHeight: '330px', maxWidth: '100%', height: 'auto' }} />
							</div>
							<br/><br/>
						</>
						:
						''
					}
					<div className="col-md-12 text-center">
						<div className='row'>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
							<div className='col-md-4' style={{textAlign:'left'}}><b>Nama Perangkat</b></div>
							<div className='col-md-4' style={{textAlign:'left'}}>: &nbsp; {dt.nama}</div>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
						</div>
						<br/>
						<div className='row'>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
							<div className='col-md-4' style={{textAlign:'left'}}><b>Jabatan</b></div>
							<div className='col-md-4' style={{textAlign:'left'}}>: &nbsp; {dt.data_jabatan_lembaga?dt.data_jabatan_lembaga.nama:''}</div>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
						</div>
						<br/>
						<div className='row'>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
							<div className='col-md-4' style={{textAlign:'left'}}><b>Bidang Jabatan</b></div>
							<div className='col-md-4' style={{textAlign:'left'}}>: &nbsp; {dt.data_bidang_lembaga?dt.data_bidang_lembaga.nama:''}</div>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
						</div>
						<br/>
						<div className='row'>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
							<div className='col-md-4' style={{textAlign:'left'}}><b>Status</b></div>
							<div className='col-md-4' style={{textAlign:'left'}}>: &nbsp; {dt.status && dt.status===0?'Tidak Aktif':'Aktif'}</div>
							<div className='col-md-2' style={{textAlign:'right'}}>&nbsp;</div>
						</div>
						<br/>
					</div>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalDetailPerangkat;
